/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const movieRatingTotalsSchema = z.object({
  totalRated: z.number(),
  totalLoved: z.number(),
  totalLiked: z.number(),
  totalDisliked: z.number(),
});

export interface IMovieRatingTotals {
  totalRated: number;
  totalLoved: number;
  totalLiked: number;
  totalDisliked: number;
}
